/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Scan_LotInputs */

const vi_stocktake_scan_lot = /** @type {(inputs: Stocktake_Scan_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã`)
};

/**

* @param {Stocktake_Scan_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_scan_lot = /** @type {((inputs?: Stocktake_Scan_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Scan_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_scan_lot(inputs)
});